/**
 * NavigationButton Component
 *
 * Extracted from Figma Crop Circle System
 * Node ID: 471-148
 */

export { NavigationButton } from './NavigationButton';
export type { NavigationButtonProps } from './NavigationButton';
